<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex h-full items-stretch gap-6">
    <div class="w-100">
      <app-form-control
        [withBottomMargin]="false"
        label="Zdjęcie główne">
        <app-multimedia-choose-or-upload-control
          [formControl]="form.controls.featuredFile" />
      </app-form-control>

      <app-form-control
        [withBottomMargin]="false"
        label="Galeria">
        <app-multimedia-choose-or-upload-multiple-control
          [formControl]="form.controls.files" />
      </app-form-control>
    </div>

    <div class="flex flex-1 flex-col bg-gray-50 p-6">
      <div>
        <app-form-control label="Nazwa">
          <input
            [formControl]="form.controls.name"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź nazwę" />
        </app-form-control>

        <app-form-control label="Odpowiednik magazynowy">
          <p-select
            (onFilter)="handleWarehouseGoodSelectFilterChange($event)"
            [filter]="true"
            [formControl]="form.controls.warehouseProductId"
            [options]="valueOrDefault(warehouseGoodSelectItems$ | async, [])"
            appPrimengSelect
            [fluid]="true"
            placeholder="Wybierz powiązany produkt z magazynu" />

          <app-warehouse-good-usage-status
            [currentObjectType]="warehouseGoodType.Cosmetic"
            [currentObjectId]="data()?.id"
            [goodId]="currentGoodId$ | async" />
        </app-form-control>

        <app-form-control label="Marka kosmetyczna">
          <p-select
            [filter]="true"
            [formControl]="form.controls.cosmeticBrandId"
            [options]="valueOrDefault(brandSelectItems$ | async, [])"
            appPrimengSelect
            [fluid]="true"
            placeholder="Wybierz markę kosmetyczną" />
        </app-form-control>

        <app-form-control label="Cena">
          <p-input-number
            [fluid]="true"
            [formControl]="form.controls.price"
            [min]="0"
            currency="PLN"
            mode="currency"
            placeholder="Wprowadź cenę" />
        </app-form-control>

        @if (isEditContext()) {
          <app-form-control label="Slug">
            <input
              [formControl]="form.controls.slug"
              placeholder="Wprowadź slug"
              appPrimengInputText
              pInputText />
          </app-form-control>
        }

        <app-form-control label="Status">
          <p-select
            [formControl]="form.controls.status"
            [options]="valueOrDefault(cosmeticStatusSelectItems$ | async, [])"
            appPrimengSelect
            [fluid]="true"
            placeholder="Wybierz status" />
        </app-form-control>

        <app-form-control
          hint="Przykład: https://domain.com"
          label="Strona zakupowa produktu">
          <input
            [formControl]="form.controls.vendorUrl"
            appPrimengInputText
            pInputText
            placeholder="Wprowadź stronę zakupową produktu" />
        </app-form-control>

        <app-form-control
          hint="Przykład: pojemność, waga"
          label="Atrybuty produktu">
          <app-admin-cosmetic-attributes-control
            [formControl]="form.controls.attributes" />
        </app-form-control>

        <app-form-control
          hint="Przykład: opis, składniki"
          label="Charakterystyka produktu">
          <app-admin-cosmetic-characteristics-control
            [formControl]="form.controls.characteristics" />
        </app-form-control>
      </div>

      <div class="mt-auto flex justify-end">
        <p-button
          [disabled]="form.invalid"
          appPrimengButton
          label="Zapisz"
          severity="primary"
          type="submit" />
      </div>
    </div>
  </div>
</form>
